import { openUploadDsdModal } from "@/components/modals/upload-dsd";
import {
  RecentReportCard,
  useRecentReports,
} from "@/components/recent-reports";
import { useOpenReport } from "@/hooks/use-open-report";
import { Button } from "@/toggle-ui-kit/button";
import { logHomeServiceAccess, logHomeWork } from "@/utils/usage-log";
import { ChevronRight, FileUp, Loader2 } from "lucide-react";
import { useNavigate } from "react-router-dom";

const RECENT_LIMIT = 5;

// 집계에서 STEP 카드 로그와 묶이도록 steps.tsx 의 label 과 같게 쓴다
const STEP_LABEL = "XBRL 태깅";

/** STEP4 XBRL 태깅 — DSD 를 올려 태깅 화면을 새 탭으로 열거나, 최근 수정한 보고서로 바로 간다. */
export const XbrlTaggingPanel = () => {
  const navigate = useNavigate();
  const openReport = useOpenReport();
  const { reports, isAuthorLoading, isLoading, isError, refetch } =
    useRecentReports(RECENT_LIMIT);

  return (
    <>
      <div className="flex w-full items-start justify-between">
        <Button
          size={40}
          onClick={() => {
            logHomeServiceAccess(`${STEP_LABEL} 패널`, "DSD 워크북 전체보기");
            navigate("/workbooks");
          }}
        >
          DSD 워크북 전체보기
        </Button>
        {/* 업로드가 끝나면 모달이 태깅 화면을 새 탭으로 연다 */}
        <Button
          variant="solid"
          size={40}
          className="bg-blue-500"
          leftIcon={<FileUp strokeWidth={1.8} />}
          onClick={() => {
            logHomeWork(STEP_LABEL, "DSD 보고서 업로드");
            openUploadDsdModal();
          }}
        >
          DSD 보고서 업로드
        </Button>
      </div>
      <section className="flex w-full flex-col gap-2 pt-6">
        <div className="flex items-center justify-between">
          <h3 className="label-1-normal-semibold text-label-neutral">
            최근 수정한 보고서
          </h3>
          <Button
            size={28}
            className="border-0"
            rightIcon={<ChevronRight strokeWidth={1.8} />}
            onClick={() => {
              logHomeServiceAccess(`${STEP_LABEL} 패널`, "최근 보고서 더보기");
              navigate("/workbooks");
            }}
          >
            더보기
          </Button>
        </div>
        <ul className="flex w-full flex-col divide-y divide-line-normal rounded-lg border border-line-normal p-4">
          {isLoading ? (
            <li className="flex justify-center py-6">
              <Loader2 className="size-5 animate-spin text-neutral-400" />
            </li>
          ) : isError ? (
            // 조회 실패를 "없음"으로 보여주면 사용자가 보고서가 없다고 받아들인다.
            <li className="caption-1-medium flex flex-col items-center gap-1 py-6 text-center text-label-alternative">
              <span>최근 수정한 보고서를 불러오지 못했습니다.</span>
              <Button size={28} className="border-0" onClick={() => refetch()}>
                다시 시도
              </Button>
            </li>
          ) : reports.length === 0 ? (
            <li className="caption-1-medium py-6 text-center text-label-alternative">
              최근 수정한 보고서가 없습니다.
            </li>
          ) : (
            reports.map((report) => (
              <li key={report.id} className="py-4 first:pt-0 last:pb-0">
                <RecentReportCard
                  report={report}
                  size="compact"
                  isAuthorLoading={isAuthorLoading}
                  onClick={() => {
                    logHomeServiceAccess(
                      `${STEP_LABEL} 패널`,
                      "최근 보고서 열기",
                    );
                    openReport(report.id);
                  }}
                />
              </li>
            ))
          )}
        </ul>
      </section>
    </>
  );
};
